exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aplayer .aplayer-lrc p.aplayer-lrc-current {\n  opacity: 1;\n  overflow: visible;\n  height: auto !important;\n  min-height: 17px;\n  font-size: 16px;\n  color: #FE9600;\n  text-shadow: none; }\n\n.aplayer.aplayer-fixed .aplayer-lrc {\n  bottom: .9rem !important; }\n", ""]);

// exports
